/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_soldil_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What does C1V1 = C2V2 mean?`)
};

const es_soldil_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué significa C1V1 = C2V2?`)
};

const de_soldil_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was bedeutet C1V1 = C2V2?`)
};

const nl_soldil_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat betekent C1V1 = C2V2?`)
};

const fr_soldil_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que signifie C1V1 = C2V2 ?`)
};

const it_soldil_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cosa significa C1V1 = C2V2?`)
};

const pt_br2_soldil_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que significa C1V1 = C2V2?`)
};

const pt_soldil_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que significa C1V1 = C2V2?`)
};

const ja_soldil_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`C1V1 = C2V2 とは何ですか？`)
};

const zh_soldil_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`C1V1 = C2V2 是什么意思？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const soldil_faq_q1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.soldil_faq_q1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("soldil_faq_q1", locale)
	if (locale === "en") return en_soldil_faq_q1(inputs)
	if (locale === "es") return es_soldil_faq_q1(inputs)
	if (locale === "de") return de_soldil_faq_q1(inputs)
	if (locale === "nl") return nl_soldil_faq_q1(inputs)
	if (locale === "fr") return fr_soldil_faq_q1(inputs)
	if (locale === "it") return it_soldil_faq_q1(inputs)
	if (locale === "pt-BR") return pt_br2_soldil_faq_q1(inputs)
	if (locale === "pt") return pt_soldil_faq_q1(inputs)
	if (locale === "ja") return ja_soldil_faq_q1(inputs)
	return zh_soldil_faq_q1(inputs)
};